const CURRENCY_FORMAT = new Intl.NumberFormat("en-AU", {
  currency: "AUD",
  style: "currency",
});

/** Money for display, always as AUD for now (the UI model doesn't carry the order's currency yet); undefined is "—". */
export const formatCurrency = (amount: number | undefined): string => {
  if (amount === undefined) {
    return "—";
  }
  return CURRENCY_FORMAT.format(amount);
};
